module.exports = __webpack_public_path__ + "img/arrow-up-right-from-square.d267792d.svg";